import React, { useRef } from "react";
import { InputNumber } from "antd";

interface PercentageInputProps {
  onChange?: (value: number) => void;
  decimalPoints?: number;
  [key: string]: any;
}

function roundDownToNearestDecimalPlaces(value: number, decimalPlaces: number): number {
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(value * factor) / factor;
}

export const PercentageInput: React.FC<PercentageInputProps> = ({
  onChange = () => {},
  decimalPoints = null,
  ...others
}) => {
  const inputNumberRef = useRef<any>(null);
  return (
    <InputNumber
      {...others}
      ref={inputNumberRef}
      onClick={() => {
        if (inputNumberRef.current) {
          inputNumberRef.current.select();
        }
      }}
      onFocus={() => {
        if (inputNumberRef.current) {
          inputNumberRef.current.select();
        }
      }}
      min={0}
      formatter={(value, info) => {
        return `${
          value !== undefined && decimalPoints
            ? roundDownToNearestDecimalPlaces(value, decimalPoints)
            : value
        }${info.userTyping ? "" : "%"}`;
      }}
      parser={(value) => (value || "").replace("%", "") as any}
      onChange={(newValue) => {
        let value = 0;
        if (typeof newValue === "number") {
          value = newValue;
        } else if (typeof newValue === "string") {
          try {
            value = parseFloat(newValue);
          } catch (e) {
            value = 0;
          }
        }
        onChange &&
          onChange(decimalPoints ? roundDownToNearestDecimalPlaces(value, decimalPoints) : value);
      }}
    />
  );
};
